module.exports = __webpack_public_path__ + "media/7.897cd0bb.mp3";